module.exports = __webpack_public_path__ + "static/media/hotelPipa1.6c55d442.jpg";